import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import BottomNav from "../components/BottomNav";
import InternalHeader from "../components/InternalHeader";
import { api } from "../lib/api";

export default function DynamicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    api("/get-single-page", { method: "POST", body: JSON.stringify({ slug }) })
      .then((response) => {
        if (!response) throw new Error("Esta página no está disponible.");
        setPage(response);
      })
      .catch((requestError) => setError(requestError.message))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <main className="food-app">
      <InternalHeader title={page?.name || page?.title || "Información"} backTo="/pages" />
      <article className="dynamic-page">
        {loading && <div className="food-message"><b>Cargando…</b></div>}
        {error && <div className="food-message food-message--error"><b>{error}</b></div>}
        {page && (
          <>
            <div className="dynamic-page__content" dangerouslySetInnerHTML={{ __html: page.body || page.content || "" }} />
          </>
        )}
      </article>
      <BottomNav />
    </main>
  );
}
